import { useDialogForm } from '@mews-commander/form';
import { lt, useDialog } from '@mews/framework';
import { DropDownButton, DropdownItem, Icon, IconButton, IconName } from '@optimus-web/core';
import { ContractsTextKey as TextKey } from '../../../../ContractsTextKey';
import { DeleteDialog } from '../../../common/DeleteDialog';
import { EditFileForm } from '../forms/EditFileForm';
import { useDeleteAttachmentMutation } from '../hooks/useDeleteAttachmentMutation';
import { AttachmentDetailsDialog } from '../attachmentDialog/AttachmentDetailsDialog';
import { useOpenAttachmentInNewTab } from '../hooks/useOpenAttachmentInNewTab';

export const ActionCell = ({ attachmentName, attachmentId }: { attachmentName: string; attachmentId: string }) => {
    const [{ onClose: onDetailsDialogClose, active: isDetailsDialogActive }, openDetailsDialog] = useDialog();
    const [{ onClose: onDeleteDialogClose, active: isDeleteDialogActive }, openDeleteDialog] = useDialog();
    const { mutate: deleteAttachment, isPending: isAttachmentDeletePending } = useDeleteAttachmentMutation();
    const { mutate: openAttachment, isPending } = useOpenAttachmentInNewTab();

    const [renderEditForm, toggleEditForm] = useDialogForm({
        title: attachmentName,
        renderForm: (props) => <EditFileForm {...props} attachmentId={attachmentId} />,
        size: 'small',
    });

    return (
        <>
            <IconButton
                onClick={() => {
                    openAttachment({ id: attachmentId });
                }}
                icon={IconName.Show}
                size="small"
                variant="ghost"
                type="button"
                loading={isPending}
            />
            <DropDownButton icon={IconName.More} size="small" variant="ghost">
                <DropdownItem
                    label={lt('ViewDetails')}
                    leftDetail={<Icon value={IconName.Info} size="small" />}
                    onClick={() => openDetailsDialog()}
                />
                <DropdownItem
                    label={lt('Edit')}
                    leftDetail={<Icon value={IconName.Edit} size="small" />}
                    onClick={toggleEditForm}
                />
                <DropdownItem
                    label={lt('Delete')}
                    leftDetail={<Icon value={IconName.Delete} size="small" />}
                    onClick={openDeleteDialog}
                />
            </DropDownButton>
            <DeleteDialog
                isActive={isDeleteDialogActive}
                onClose={onDeleteDialogClose}
                title={lt(TextKey.ContractAttachmentDeleteConfirmationTitle)}
                description={lt(TextKey.ContractAttachmentDeleteConfirmationDescription)}
                onDelete={() => deleteAttachment({ id: attachmentId })}
                loading={isAttachmentDeletePending}
            />
            <AttachmentDetailsDialog
                isActive={isDetailsDialogActive}
                onClose={() => onDetailsDialogClose()}
                attachmentId={attachmentId}
            />
            {renderEditForm()}
        </>
    );
};
